import type { RequestInfo } from '@ember-data/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/**
 * State-transition against `/tas-eligibilities`:
 *   PATCH /tas-eligibilities/:id/transition/state/(activate|deactivate)
 */
export function updateTasEligibilityStateRequest(
  tasEligibilityId: string,
  eligibilityState: 'activate' | 'deactivate'
): RequestInfo {
  const opts: QueryUrlOptions = {
    identifier: { type: 'tas-eligibilities' },
    op: 'query',
    resourcePath: 'tas-eligibilities',
  };
  return {
    url: `${buildBaseURL(opts)}/${tasEligibilityId}/transition/state/${eligibilityState}`,
    method: 'PATCH',
    cacheOptions: { [SkipCache]: true },
  };
}
